var map = {
	"./common.yml": 28087,
	"./hartvannederland.yml": 12960,
	"./kijk.yml": 28027,
	"./radio10.yml": 96100,
	"./radio538.yml": 99252,
	"./shownieuws.yml": 79498,
	"./skyradio.yml": 7261,
	"./vandaaginside.yml": 3259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41529;